import React, {FunctionComponent} from "react";
import WizardStep from "../../WizardStep";
import statusReference from "../../../../images/Progress/progress_referenznummer.svg";
import UncertainInput from "../../../../commonComponents/UncertainInput";
import {Step} from "../../../WizardMap";
import {ValidatorForm} from "react-material-ui-form-validator";
import {isUncertainInfoEmpty} from "../../../state/utils";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../redux/rootReducer";
import {setRefNrValue, toggleRefNrUnknown} from "../../../state/disposalSlice";
import {NavigationProps} from "../../../slideRouter/navigationHook";

const StepWatchReference: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const dispatch = useDispatch();
    const {currentDisposal: {referenceNumber}} = useSelector((state: RootState) => state.disposal);

    return (
        <WizardStep
            title={"Wie lautet die Referenznummer?"}
            icon={statusReference}
            backButton={true}
            onBackClick={gotoPrevSlide}
            nextButton={true}
            nextButtonDisabled={isUncertainInfoEmpty(referenceNumber)}
            onNextClick={() => gotoNextSlide(Step.ADD_INFO)}
        >
            <ValidatorForm onSubmit={() => !isUncertainInfoEmpty(referenceNumber) && gotoNextSlide(Step.ADD_INFO)}>
                <UncertainInput
                    textInputLabel={"Referenznummer"}
                    textInputValue={referenceNumber ? referenceNumber.value : ""}
                    inputDisabled={referenceNumber && referenceNumber.unknown}
                    onChangeText={(text: string) => dispatch(setRefNrValue(text))}
                    checkBoxLabel={"Unbekannt"}
                    checkboxChecked={referenceNumber && referenceNumber.unknown}
                    onCheckBoxClick={() => dispatch(toggleRefNrUnknown())}
                />
            </ValidatorForm>
        </WizardStep>
    );
};

export default StepWatchReference;
